import { Link } from "react-router-dom";
import { DEFAULT_AVATAR, type Patient } from "../api/client";
import { formatMediumDate, titleize } from "../lib/format";

export type PatientsTableProps = {
  patients: Patient[];
};

/** Historical patients list table with activation LED. */
export function PatientsTable({ patients }: PatientsTableProps) {
  return (
    <div className="ne__patients__table">
      <div className="ne__table__padding">
        <table className="ne__table ne__table--avatar">
          <thead>
            <tr>
              <th />
              <th className="ne__table__eyebrow">Name</th>
              <th className="ne__table__eyebrow">Date of Birth</th>
              <th className="ne__table__eyebrow">Email</th>
              <th className="ne__table__eyebrow">Cell phone</th>
              <th className="ne__table__eyebrow">Last seen</th>
              <th className="ne__table__eyebrow ne__table__center">
                Account active
              </th>
            </tr>
          </thead>
          <tbody>
            {patients.map((user) => {
              // Angular list omits account_activated → gray LED. Only explicit true is green.
              const activated = user.account_activated === true;
              return (
                <tr key={user.id}>
                  <td>
                    <Link to={`/app/patients/${user.id}/activity`}>
                      <figure className="ne__avatar">
                        <img
                          src={user.profile_url || DEFAULT_AVATAR}
                          alt=""
                        />
                      </figure>
                    </Link>
                  </td>
                  <td>
                    <Link to={`/app/patients/${user.id}/activity`}>
                      <h4 className="ne__patients__patient-name">
                        {titleize(user.name)}
                      </h4>
                    </Link>
                  </td>
                  <td className="ne__patients__data">
                    {formatMediumDate(user.bio?.date_of_birth || user.birthday)}
                  </td>
                  <td className="ne__patients__data">{user.email}</td>
                  <td className="ne__patients__data">
                    {user.bio?.phone_number || user.phone}
                  </td>
                  <td className="ne__patients__data">
                    {user.last_check_in
                      ? formatMediumDate(user.last_check_in)
                      : ""}
                  </td>
                  <td className="ne__table__center">
                    <div className="ne__table__led">
                      <i
                        className={`ne__icon__dot ${activated ? "green" : "gray"}`}
                      />
                      <span>
                        {activated
                          ? "Account activated"
                          : "Account not activated"}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export type PatientSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function PatientSearchField({
  value,
  onChange,
  placeholder = "Search patients",
}: PatientSearchFieldProps) {
  return (
    <div className="ne__patients__search">
      <fieldset className="ne__search ne__search--exposed">
        <label>
          <input
            className="ne__search__input"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            aria-label={placeholder}
          />
        </label>
      </fieldset>
    </div>
  );
}
